import { cn } from "@repo/utils";
import type { DialogBaseProps } from "../dialog.types.js";

export const DialogTitle = ({ className, children }: DialogBaseProps) => {
  return (
    <h2 className={cn("text-lg leading-none font-semibold tracking-tight", className)}>
      {children}
    </h2>
  );
};
